if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.content = this.querySelector('.product-media-modal__content');
        this.previousButton = this.querySelector('[data-image-previous]');
        this.nextButton = this.querySelector('[data-image-next]');

        if (this.previousButton && this.nextButton) {
          this.querySelector('.product-media-modal__navigation').addEventListener('pointerup', (event) => {
            event.stopPropagation();
          });
          this.previousButton.addEventListener('click', () => this.moveImage(-1));
          this.nextButton.addEventListener('click', () => this.moveImage(1));
          this.content.addEventListener('scroll', () => {
            if (!this.classList.contains('has-image-navigation')) return;
            cancelAnimationFrame(this.scrollFrame);
            this.scrollFrame = requestAnimationFrame(() => this.updateActiveImage());
          }, { passive: true });
        }
      }

      hide() {
        super.hide();
        this.classList.remove('has-image-navigation');
        cancelAnimationFrame(this.scrollFrame);
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.content.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        this.images = Array.from(this.content.children).filter((element) => element.tagName === 'IMG');
        this.classList.toggle('has-image-navigation', this.hasAttribute('data-image-navigation') && activeMedia.tagName === 'IMG' && this.images.length > 1);

        if (this.classList.contains('has-image-navigation')) {
          this.activeImageIndex = this.images.indexOf(activeMedia);
          this.updateButtons();
          requestAnimationFrame(() => this.scrollToImage(this.activeImageIndex, false));
        } else {
          activeMedia.scrollIntoView();
        }

        const container = this.querySelector('[role="document"]');
        if (!this.classList.contains('has-image-navigation')) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      moveImage(direction) {
        const index = Math.max(0, Math.min(this.images.length - 1, this.activeImageIndex + direction));
        if (index === this.activeImageIndex) return;
        this.activeImageIndex = index;
        this.updateButtons();
        this.scrollToImage(index, true);
      }

      scrollToImage(index, smooth) {
        const image = this.images[index];
        if (!image || !this.hasAttribute('open')) return;
        const behavior = smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant';
        if (window.matchMedia('(max-width: 749px)').matches) {
          const left = image.getBoundingClientRect().left - this.content.getBoundingClientRect().left + this.content.scrollLeft;
          this.content.scrollTo({ left, behavior });
        } else {
          image.scrollIntoView({ behavior, block: 'center' });
        }
      }

      updateActiveImage() {
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const center = isMobile
          ? this.content.getBoundingClientRect().left + this.content.clientWidth / 2
          : this.content.getBoundingClientRect().top + this.content.clientHeight / 2;
        let closestDistance = Infinity;
        this.images.forEach((image, index) => {
          const rect = image.getBoundingClientRect();
          const imageCenter = isMobile ? rect.left + rect.width / 2 : rect.top + rect.height / 2;
          const distance = Math.abs(imageCenter - center);
          if (distance < closestDistance) {
            closestDistance = distance;
            this.activeImageIndex = index;
          }
        });
        this.updateButtons();
      }

      updateButtons() {
        this.previousButton.disabled = this.activeImageIndex === 0;
        this.nextButton.disabled = this.activeImageIndex === this.images.length - 1;
      }
    }
  );
}
